import watchListAllRelatorioEstoquePorPeriodo from './saga/estoquePorPeriodo';

export const relatorioEstoquePorPeriodoSaga = [
    watchListAllRelatorioEstoquePorPeriodo(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
